"use client";
import { Clock, Filter, Users, Wand2 } from "lucide-react";
// import { useSession } from "next-auth/react";
import Link from "next/link";
import { useParams, useRouter } from "next/navigation";
import { useContext, type FC } from "react";
import { C, type ContextValue } from "@src/utils/context";
import { FilterSection } from "../macroComponent/Tag";
import { useSupabaseAuth } from "@src/utils/SupabaseAuthContext";
import { useUser } from "@supabase/auth-helpers-react";

const MainBodyHeader: FC = () => {
  const query = useParams();
  const tab = query.tab
  const { user } = useSupabaseAuth();
  const { filter, setFilter } = useContext(C) as ContextValue;

  return (
    <>
      <header className="w-full overflow-auto border-b border-border-light pt-2 dark:border-border">
        <div className="flex w-full items-end justify-between gap-16 px-2">
          <div className="flex items-center gap-2">
            <Link href="/?tab=personalized">
              <button
                aria-label="icon"
                role="button"
                className={`${tab === undefined || tab === "personalized"
                  ? "btn-tab-active"
                  : "btn-tab"
                  }`}
              >
                {/* <Wand2
                  className={`h-4 w-4  ${tab === undefined || tab === "personalized"
                    ? "fill-secondary"
                    : "stroke-gray-700 dark:stroke-text-secondary"
                    }`}
                /> */}

                <Clock
                  className={`h-4 w-4  ${tab === undefined || tab === "personalized"
                    ? "stroke-secondary"
                    : "stroke-gray-700 dark:stroke-text-secondary"
                    }`}
                />

                <span className="text-sm font-semibold">Latest</span>
              </button>
            </Link>

            {/* {user && (
              <Link href="/?tab=following">
                <button
                  aria-label="icon"
                  role="button"
                  className={`${tab === "following" ? "btn-tab-active" : "btn-tab"
                    }`}
                >
                  <Users
                    className={`h-4 w-4 fill-none ${tab === "following"
                      ? "stroke-secondary"
                      : "stroke-gray-700 dark:stroke-text-secondary"
                      }`}
                  />

                  <span className="text-sm font-semibold">Following</span>
                </button>
              </Link>
            )} */}

            {/* <Link href="/?tab=latest">
              <button
                aria-label="icon"
                role="button"
                className={`${tab === "latest" ? "btn-tab-active" : "btn-tab"}`}
              >
                <Clock
                  className={`h-4 w-4 fill-none ${tab === "latest"
                    ? "stroke-secondary"
                    : "stroke-gray-700 dark:stroke-text-secondary"
                    }`}
                />

                <span className="text-sm font-semibold">Latest</span>
              </button>
            </Link> */}
          </div>

          {/* <div className="flex items-center gap-2">
            <div
              onClick={() => {
                setFilter((prev) => ({
                  ...prev,
                  status: !prev.status,
                }));
              }}
              className="btn-tab cursor-pointer"
            >
              <button
                aria-label="icon"
                role="button"
                className="relative flex items-center justify-center"
              >
                <Filter
                  className={`h-4 w-4 ${filter.data.read_time !== null ||
                    filter.data.tags.length > 0
                    ? "fill-none stroke-secondary"
                    : "stroke-gray-700 dark:stroke-text-secondary"
                    }`}
                />
              </button>

              <span
                className={`${filter.data.read_time !== null || filter.data.tags.length > 0
                  ? "text-secondary"
                  : "text-gray-700 dark:text-text-secondary"
                  }`}
              >
                Filter
              </span>
            </div>
          </div> */}
        </div>
      </header>

      {filter.status && (
        <FilterSection />
      )}
    </>
  );
};

export default MainBodyHeader;
